import { computed } from 'vue'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'

import {
  disconnectTelegramAccount,
  getTelegramAccount,
  getTelegramLink
} from '../api'

import { telegramAccountKeys } from './keys'

export function useTelegramAccount() {
  const query = useQuery({
    queryKey: telegramAccountKeys.all,
    queryFn: ({ signal }) => getTelegramAccount({ signal })
  })

  return {
    ...query,
    account: computed(() => query.data.value?.data.data ?? null)
  }
}

export function useTelegramLink() {
  return useMutation({ mutationFn: getTelegramLink })
}

export function useDisconnectTelegramAccount() {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: disconnectTelegramAccount,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: telegramAccountKeys.all })
    }
  })
}
